export type MetaFile = {
  readonly file_meta: Record<string, string>
}
